enum TagId {
  SingleOwner = 20,
  AccidentFree = 21,
  PriceDrop = 103,
  GreatDeal = 104,
  SportsVehicle = 118,
  LowMileage = 119,
  LowMilesPerYear = 120,
  RecentlyAdded = 121
}

export default TagId;
